import styled from 'styled-components';

export const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
